import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestBugherdContext(projectId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/bugherd/project/${projectId}/context`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestBugherdBoards(clientId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/bugherd/${clientId}/boards`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSyncBugherdBoard(projectId) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/bugherd/project/${projectId}/sync`,
        // The server checks its 45s deadline between BugHerd calls, so one in-flight call can carry it past that: this has to outlast the overshoot rather than race it.
        timeout: 90000,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDisconnectBugherd(clientId) {
    return axios.request({
        method: "delete",
        url: `${getApiUrl()}/bugherd/${clientId}/connection`,
        withCredentials: true,
        crossorigin: true,
    });
}
